const TOP = 'TOP'
const BOTTOM = 'BOTTOM'

export default {
    methods: {
        /**
         * `offset` only matters for sensors at the top of the equipment, `offset_bottom` for those at the bottom.
         * An unknown position (no device, no referential, position not set) keeps both fields.
         *
         * @param {import('@/models/IDevice').IDevice[] | undefined} devices
         * @returns {string[]}
         */
        getHiddenOffsetKeys(devices) {
            if (!devices || devices.length === 0) {
                return []
            }

            const positions = devices.map((device) => (device.device_referentiel ? device.device_referentiel.sensor_position : null))
            const hiddenKeys = []
            if (positions.every((position) => position === BOTTOM)) {
                hiddenKeys.push('offset')
            }
            if (positions.every((position) => position === TOP)) {
                hiddenKeys.push('offset_bottom')
            }

            return hiddenKeys
        },
    },
}
